import { selectFromCustomFieldPreferencesDto } from '../../models';

export default selectFromCustomFieldPreferencesDto()
  .customFields
  .toString();
